"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Forms = _interopRequireWildcard(require("./"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DataArray extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      data: this.props.value || this.props.schema.array.map(row => row.value)
    });
    _defineProperty(this, "handleChange", (index, value) => {
      this.setState(state => {
        const {
          data
        } = state;
        data[index] = value;
        return {
          data
        };
      }, () => this.props.onChange(this.state.data));
    });
    _defineProperty(this, "render", () => {
      return /*#__PURE__*/_react.default.createElement("div", null, this.props.schema.array.map(field => {
        const Component = Forms[field.type];
        return /*#__PURE__*/_react.default.createElement("div", {
          key: field.key,
          className: 'form-group row'
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "col-sm-2 text-muted text-uppercase"
        }, /*#__PURE__*/_react.default.createElement("small", null, field.displayName)), /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-10"
        }, /*#__PURE__*/_react.default.createElement(Component, {
          onChange: value => this.handleChange(field.key, value),
          value: this.state.data[field.key]
        })));
      }));
    });
  }
}
var _default = exports.default = DataArray;
module.exports = exports.default;